import type { SVGProps } from 'react';

import { cn } from '../../lib/cn';

/** Logo Google officiel, couleurs figées, ne suit pas `currentColor`. */
export function GoogleIcon({ className, ...props }: Omit<SVGProps<SVGSVGElement>, 'viewBox'>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      className={cn('size-5 shrink-0', className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.16363 12C5.16363 11.2379 5.29021 10.5072 5.51613 9.82186L1.56172 6.80212C0.791027 8.36692 0.356812 10.1301 0.356812 12C0.356812 13.8683 0.790493 15.6304 1.56012 17.1941L5.51239 14.1685C5.28861 13.4864 5.16363 12.7584 5.16363 12Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1069 5.06666C13.7625 5.06666 15.258 5.65333 16.433 6.61333L19.8512 3.2C17.7682 1.38666 15.0978 0.266663 12.1069 0.266663C7.46347 0.266663 3.47274 2.92213 1.56177 6.80213L5.51618 9.82186C6.42734 7.056 9.02462 5.06666 12.1069 5.06666Z"
        fill="#EB4335"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1069 18.9333C9.02462 18.9333 6.42734 16.944 5.51618 14.1781L1.56177 17.1973C3.47274 21.0778 7.46347 23.7333 12.1069 23.7333C14.9728 23.7333 17.7089 22.7157 19.7625 20.809L16.0089 17.9072C14.9498 18.5744 13.6162 18.9333 12.1069 18.9333Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.3227 12C23.3227 11.3066 23.2159 10.56 23.0557 9.86664H12.1068V14.4H18.4091C18.094 15.9456 17.2362 17.1338 16.0089 17.9072L19.7625 20.809C21.9197 18.8069 23.3227 15.8245 23.3227 12Z"
        fill="#4285F4"
      />
    </svg>
  );
}
